import { render, staticRenderFns } from "./UserMedicalCard.vue?vue&type=template&id=1206022e&scoped=true"
import script from "./UserMedicalCard.vue?vue&type=script&lang=js"
export * from "./UserMedicalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206022e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1206022e')) {
      api.createRecord('1206022e', component.options)
    } else {
      api.reload('1206022e', component.options)
    }
    module.hot.accept("./UserMedicalCard.vue?vue&type=template&id=1206022e&scoped=true", function () {
      api.rerender('1206022e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/components/UserMedicalCard.vue"
export default component.exports